import { useQuery } from '@tanstack/react-query';
import { workTicketApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

/** @registry One work ticket; the edit form's pre-fill source. */
export function useWorkTicket(
  jobId: number | null | undefined,
  ticketId: string | null | undefined,
) {
  return useQuery({
    queryKey: queryKeys.workTickets.detail(jobId ?? -1, ticketId ?? ''),
    queryFn: ({ signal }) =>
      workTicketApiClient.get(ticketId!, toCancelToken(signal)),
    enabled: !!ticketId && jobId != null && jobId > 0,
    staleTime: 0,
    meta: { errorContext: 'work ticket detail' },
  });
}
